import React, { useEffect, useReducer } from "react";
import CardDownload from "../../Components/CardDownload";
import CardReport from "../../Components/CardReport";
// import Contact from "../../Components/Contact";
import SecondaryBanner from "../../Components/SecondaryBanner";

const PriceSensitiveInformation = () => {
  useEffect(() => {
    document.title = "Price Sensitive Information";
    window.scrollTo(0, 0);
  }, []);
  const bannerData = {
    breadcrumb: [
      "Home",
      "Investor Relationship",
      "Price Sensitive Information",
    ],
    bannerTitle: "Price Sensitive Information",
  };
  const initialState = {
    selectedYear: "all",
  };
  const reducer = (state, action) => {
    switch (action.type) {
      case "changeYear":
        return { ...state, selectedYear: action.year };
      default:
        throw new Error("Action type not defined");
    }
  };
  const [state, dispatch] = useReducer(reducer, initialState);
  const cardData = [
    {
      id: 1,
      title: "Book Closure Notice 2079-01-26",
      link: "https://gurkhasfinance.com.np/assets/price sensitive information/stock.pdf",
      year: "",
    },
  ];
  return (
    <main>
      <SecondaryBanner bannerData={bannerData} />
      <section class="section-sub-header">
        <div class="container">
          <div class="content">
            <div class="location-dropdown">
              <select
                id="year-dropdown"
                onClick={(e) =>
                  dispatch({ type: "changeYear", year: e.target.value })
                }
              >
                <option value="all">All Fiscal Year</option>
                <option value="2078/79">2078/79</option>
              </select>
            </div>
          </div>
        </div>
      </section>
      <section className="section-report">
        <div className="container">
          <div className="card-row">
            {state.selectedYear === "all"
              ? cardData.map((card) => (
                <CardDownload
                  cardTitle={card.title}
                  link={card.link}
                  key={card.id}
                />
              ))
              : cardData.map(
                (card) =>
                  card.year === state.selectedYear && (
                    <CardDownload
                      cardTitle={card.title}
                      link={card.link}
                      key={card.id}
                    />
                  )
              )}
          </div>
        </div>
      </section>
      {/* <section class="section-report">
        <div class="container">
          <div class="card-row">
            <CardDownload
              date={"Shrawan 1, 2078"}
              cardTitle={"Title or highlights of information here"}
              link={"#"}
            />
            <CardDownload
              date={"Shrawan 1, 2078"}
              cardTitle={"Title or highlights of information here"}
              link={"#"}
            />
            <CardDownload
              date={"Shrawan 1, 2078"}
              cardTitle={"Title or highlights of information here"}
              link={"#"}
            />
            <CardDownload
              date={"Shrawan 1, 2078"}
              cardTitle={"Title or highlights of information here"}
              link={"#"}
            />
            <CardDownload
              date={"Shrawan 1, 2078"}
              cardTitle={"Title or highlights of information here"}
              link={"#"}
            />
          </div>
        </div>
      </section> */}
    </main>
  );
};

export default PriceSensitiveInformation;
